import type { ReceiptTemplate } from '../schema';

export const walmartTemplate: ReceiptTemplate = {
  id: 'walmart',
  name: 'Walmart Receipt',
  brand: 'Walmart',
  description: 'Realistic Walmart receipt template',
  settings: {
    width: 280,
    font: 'Bit Matrix C',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#000000',
    showWatermark: false,
    currency: 'none',
    currencyPosition: 'before',
    spacing: 'narrow',
  },
  sections: [
    // Top message above header
    {
      id: 'wm-top-msg',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'See back of receipt for your chance\nto win $1000\n\nID #:   A9T4GX7M2RB',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    // Header with logo and store info
    {
      id: 'wm-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/walmart.png',
        logoData: '',
        logoWidth: 200,
        logoHeight: 45,
        businessName: '',
        businessNameFontSize: 24,
        addressLines: [
          '( 510 ) 555 - 0127',
          'MANAGER MIKE WAZOWSKI',
          '1200 DARK AVENUE',
          'MONSTERVILLE CA 94608',
        ],
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
    // Store/Register info line
    {
      id: 'wm-store-info',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'ST# 02270 OP# 000144 TE# 02 TR# 03080',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
    // Items list with SKUs
    {
      id: 'wm-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        showQuantity: false,
        quantityPosition: 'left',
        showHeader: false,
        showHeaderDivider: false,
        headerLabels: {
          quantity: 'Qty',
          item: 'Item',
          amount: 'Price',
        },
        items: [
          { id: 'wm-item-1', name: 'AVOCADO      000000004046KI', price: '0.95 R' },
          { id: 'wm-item-2', name: 'GV MILK 2%   007874203717 F', price: '3.64 R' },
          { id: 'wm-item-3', name: 'GV BREAD WH  007874210834 F', price: '1.28 R' },
          { id: 'wm-item-4', name: 'GV EGGS LG   007874212063 F', price: '4.87 R' },
          { id: 'wm-item-5', name: 'TIDE PODS    003700096478 F', price: '14.97 X' },
        ],
        showTopDivider: false,
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
    // Totals section - no bold on total
    {
      id: 'wm-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 35,
        lines: [
          { id: 'wm-subtotal', label: 'SUBTOTAL', value: '25.71  ', isBold: false, isLarge: false },
          { id: 'wm-tax1', label: 'TAX 1 7.900%', value: '1.80  ', isBold: false, isLarge: false },
          { id: 'wm-total', label: 'TOTAL', value: '27.51  ', isBold: false, isLarge: false },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
    // Payment section
    {
      id: 'wm-payment',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'wm-cash', label: '', value: '' },
          { id: 'wm-tend-amt', label: '', value: '' },
          { id: 'wm-change', label: '', value: '' },
        ],
        column2: [
          { id: 'wm-cash-tend', label: 'CASH TEND         ', value: '30.00  ' },
          { id: 'wm-change-due', label: 'CHANGE DUE', value: '2.49  ' },
        ],
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
    // Items sold count
    {
      id: 'wm-items-count',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: '# ITEMS SOLD 5',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
    // Transaction code
    {
      id: 'wm-tc',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'TC# 5829 1044 8362 7719 540',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
    // Barcode
    {
      id: 'wm-barcode',
      type: 'barcode',
      enabled: true,
      config: {
        alignment: 'center',
        type: 'code128',
        value: '12345678984984984908498498412',
        showValue: false,
        width: 1.2,
        height: 30,
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
    // Date and time
    {
      id: 'wm-datetime',
      type: 'datetime',
      enabled: true,
      config: {
        alignment: 'center',
        dateTime: '01/03/26     14:26:03',
        format: 'MM/DD/YY    HH:mm:ss',
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
    // QR Code
    {
      id: 'wm-qr',
      type: 'barcode',
      enabled: true,
      config: {
        alignment: 'center',
        type: 'qr',
        value: 'QR_DETAILED',
        showValue: false,
        width: 2,
        height: 70,
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
  ],
};
